import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { API_CONSTANT } from '../../services/api.constant';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { CALENDAR_LOCALE } from '../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var CustomerRequestComponent = (function () {
    function CustomerRequestComponent(formBuilder, httpClient, modalService, translate, cdRef, router) {
        this.formBuilder = formBuilder;
        this.httpClient = httpClient;
        this.modalService = modalService;
        this.translate = translate;
        this.cdRef = cdRef;
        this.router = router;
        this.language = localStorage.getItem('lang') || 'en';
        this.refreshDropdown = false;
        this.confirmLoading = false;
        this.showError = false;
        this.loading = false;
        this.plusKeyPressed = false;
        this.calendarLocale = CALENDAR_LOCALE.EN;
        if (!environment.enabledCustomerRequest) {
            this.router.navigate(['/login']);
        }
    }
    CustomerRequestComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function () {
            _this.translateDropdown();
        });
        this.createBuyerRequestForm();
        this.loadCountries();
    };
    CustomerRequestComponent.prototype.translateDropdown = function () {
        var _this = this;
        this.refreshDropdown = true;
        setTimeout(function () {
            _this.refreshDropdown = false;
        }, 1);
    };
    CustomerRequestComponent.prototype.changeLanguage = function () {
        this.translate.use(this.language);
        localStorage.setItem('lang', this.language);
    };
    CustomerRequestComponent.prototype.createBuyerRequestForm = function () {
        this.buyerRequestForm = this.formBuilder.group({
            type: ['hotel', Validators.required],
            abbNo: [null, Validators.required],
            receiptIssueDate: [null, Validators.required],
            name: [null, Validators.required],
            taxID: [null, [this.validateTaxId, Validators.required]],
            branchCode: [null],
            branchName: [null],
            address: [null, Validators.required],
            postcode: [null, this.validatePostCode],
            country: [221, Validators.required],
            email: [null, [this.validateEmail, Validators.required]],
            ccEmail: [null],
            phoneNumber: [null, [Validators.required]],
            amount: ['0.00', [Validators.required]]
        });
    };
    CustomerRequestComponent.prototype.validateTaxId = function (control) {
        if (control.value && Boolean(control.value.match(/^[0-9]{13}$/g))) {
            return null;
        }
        return { taxIDInvalid: true };
    };
    CustomerRequestComponent.prototype.validateEmail = function (control) {
        if (control.value) {
            return Validators.email(control);
        }
        return null;
    };
    CustomerRequestComponent.prototype.validatePostCode = function (control) {
        if (control.value && Boolean(control.value.match(/^[0-9]{5}$/g))) {
            return null;
        }
        return { 'postalCodeInvalid': true };
    };
    CustomerRequestComponent.prototype.loadCountries = function () {
        var _this = this;
        this.httpClient.get(API_CONSTANT.country).subscribe(function (res) {
            _this.countries = res;
        });
    };
    Object.defineProperty(CustomerRequestComponent.prototype, "countryCode", {
        get: function () {
            return this.form.country.value;
        },
        enumerable: true,
        configurable: true
    });
    CustomerRequestComponent.prototype.countryChange = function (event) {
        if (event.country_code === 'TH') {
            this.form.postcode.setValidators([this.validatePostCode]);
            this.form.taxID.setValidators([this.validateTaxId, Validators.required]);
        }
        else {
            this.form.postcode.setValidators([]);
            this.form.taxID.setValidators([Validators.required]);
        }
        this.form.postcode.updateValueAndValidity();
        this.form.taxID.updateValueAndValidity();
    };
    CustomerRequestComponent.prototype.alertSubmitSuccess = function () {
        Swal.fire({
            title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-SUCCESS'),
            html: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-SUCCESS'),
            type: 'success',
            confirmButtonColor: '#02008a',
            confirmButtonText: this.translate.instant('COMMON.CLOSE'),
            customClass: {
                title: 'custom-title'
            },
            width: '600px'
        });
    };
    CustomerRequestComponent.prototype.alertSubmitFailure = function () {
        Swal.fire({
            title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-FAILED'),
            text: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-FAILED'),
            type: 'error',
            confirmButtonColor: '#02008a',
            confirmButtonText: this.translate.instant('COMMON.CLOSE'),
            customClass: {
                title: 'text-red'
            }
        });
    };
    CustomerRequestComponent.prototype.formatPhoneNumber = function (event) {
        var valueInput = event.target.value;
        var checkPlus = valueInput.includes("+");
        if (checkPlus) {
            var textValue = valueInput.replace("+", "");
            event.target.value = "+" + textValue;
            this.cdRef.detectChanges();
        }
        else {
            this.plusKeyPressed = false;
        }
    };
    CustomerRequestComponent.prototype.charValidate = function (event) {
        if ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 43 && !this.plusKeyPressed)) {
            if (event.charCode == 43) {
                this.plusKeyPressed = true;
            }
            return true;
        }
        return false;
    };
    CustomerRequestComponent.prototype.confirmation = function (modalContent) {
        this.showError = false;
        if (this.buyerRequestForm.invalid) {
            this.showError = true;
            return;
        }
        this.modal = this.modalService.open(modalContent, { centered: true, size: 'lg' });
    };
    CustomerRequestComponent.prototype.closeModal = function () {
        if (this.modal) {
            this.modal.close();
        }
    };
    CustomerRequestComponent.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        var data = {
            room_type: this.form.type.value,
            confirmation_no: '',
            abb_no: this.form.abbNo.value,
            receipt_dt: this.form.receiptIssueDate.value,
            buyer_name: this.form.name.value,
            tax_id: this.form.taxID.value,
            branch_code: this.form.branchCode.value,
            branch_name: this.form.branchName.value,
            address: this.form.address.value,
            postal_code: this.form.postcode.value,
            country: this.form.country.value,
            email: this.form.email.value,
            cc_email: this.form.ccEmail.value,
            phone_number: this.form.phoneNumber.value,
            amount: this.form.amount.value,
        };
        this.httpClient.post(API_CONSTANT.document_request, data)
            .pipe(finalize(function () {
            _this.closeModal();
            _this.loading = false;
            _this.showError = false;
        }))
            .subscribe(function () {
            _this.buyerRequestForm.reset();
            _this.form.type.setValue('hotel');
            _this.alertSubmitSuccess();
        }, function () {
            _this.alertSubmitFailure();
        });
    };
    CustomerRequestComponent.prototype.taxIDChange = function (event) {
        var _this = this;
        var taxID = event.target.value;
        if (!taxID || taxID.length !== 13) {
            return;
        }
        var params = {
            tax_id: taxID
        };
        this.httpClient.get(API_CONSTANT.buyer + "external/", { params: params }).subscribe(function (result) {
            _this.buyerRequestForm.patchValue({
                name: result['name'],
                address: result['address'],
                country: result['country_id'],
                postcode: result['post_code'],
            });
            _this.form.postcode.setValidators([_this.validatePostCode]);
            _this.form.postcode.updateValueAndValidity();
        });
    };
    Object.defineProperty(CustomerRequestComponent.prototype, "form", {
        get: function () {
            return this.buyerRequestForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    return CustomerRequestComponent;
}());
export { CustomerRequestComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.component.ts.pre-build-optimizer.js